// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__hnVtD","modalForm":"UpgradeEpcsModal_modalForm__h0TXC","modalFooter":"UpgradeEpcsModal_modalFooter__LlS3t"};